<template>
    <div class="confirmcourse-box">
        <div v-for="(item,index) in lists" :key="index">
            <div class="confirmcourse-item">
                <div class="confirmcourse-top" v-for="(element,i) in item.projects" :key="i">
                    <h4 class="confirmcourse-title">{{element.projectName}}</h4>
                    <div class="confirmcourse-name">{{element.experimentMethod}}</div>
                </div>
                <div class="confirmcourse-bottom">
                    <div class="confirmcourse-bottom-item" style="border-bottom: 1px solid #efefef;">
                        <span>订单代付金额：¥</span>
                        <span>{{Number(item.price).toFixed(2)}}</span>
                    </div>
                    <div class="confirmcourse-bottom-item">
                        <span>订单编号：</span>
                        <span>{{item.orderId}}</span>
                    </div>
                    <div class="confirmcourse-bottom-item">
                        <span>下单时间：</span>
                        <span>{{item.orderCreateTime}}</span>
                    </div>
                    <div class="confirmcourse-bottom-item">
                        <span>下 单 人：</span>
                        <span>{{item.userName}}</span>
                    </div>
                    <div class="confirmcourse-bottom-item">
                        <span>代 付 人：</span>
                        <span>{{item.oppName}}</span>
                    </div>
                    <div class="confirmcourse-bottom-item">
                        <span>联系电话：</span>
                        <span>{{item.userPhone}}</span>
                    </div>
                    <div class="confirmcourse-bottom-item">
                        <span>检测检验机构名称：</span>
                        <span>{{item.orgName}}</span>
                    </div>
                </div>
                <div class="button-box">
                    <button class="sure-button" v-if="item.ifConform === 0" @click="confirm(item)">确认</button>
                    <button class="sure-button active" v-if="item.ifConform === 1">已确认</button>
                </div>
            </div>
            <div class="blank"></div>
        </div>
        <van-overlay :show="showLogin">
            <div class="wrapper" @click.stop>
                <div class="showlogin">
                <div class="login-title">用户登录</div>
                <div class="login-box">
                    <van-field type="tel" v-model="introMobile" label="手机号" label-width="4.2em" placeholder="请输入手机号" maxlength="11"/>
                </div>
                <div class="login-box">
                    <van-field type="number" v-model="introCode" label-width="4.2em" center clearable label="验证码" maxlength="6" @input="introCode.length > 6 ? introCode:introCode.slice(0,6)" placeholder="请输入短信验证码">
                    <template #button>
                        <van-button size="small" type="primary" :disabled="codeStatus" @click="sendCode">{{codeText}}</van-button>
                    </template>
                    </van-field>
                </div>
                <div class="login-button" @click="onSubmitIntro">登 录</div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
import * as  API_ from '@/api/resetApi.js'
import { Notify, Toast } from 'vant';
export default {
    data () {
        return {
            showLogin:true,
            lists:[],

            // 注册
            introMobile:'',
            introCode:'',
            submitStatus:false,
            codeText:'获取验证码',
            countDown: 60,
            codeStatus:false,
            timer:null,
            token:'',
            userId:'',

        }
    },
    created () {
        if (sessionStorage.getItem('uToken')) {
            this.userId = sessionStorage.getItem('userId')
            this.introMobile = sessionStorage.getItem('phone')
            this.list()
            this.showLogin = false
        } else {
            this.showLogin = true
        }
    },
    mounted () {
        
    },
    methods: {
        countDowns(){
            this.timer = setInterval(()=>{
            this.countDown --
            if(this.countDown<0){
                clearInterval(this.timer);
                this.countDown = 60
                this.codeText = '重新发送'
                this.codeStatus = false
            }else{
                this.codeStatus = true
                this.codeText = this.countDown+'s'
            }
            },1000)
      },
      async sendCode(){
        const re = /^1(3|4|5|6|7|8|9)\d{9}$/
        if(!this.introMobile){
            return Toast('手机号不能为空')
        } else if(!re.test(this.introMobile)){
            return Toast('请填写正确的手机格式')
        }else{
            this.countDowns()
            const data = {
                cuPhone:this.introMobile,
                sysCode:'zkmsy',
                cpmType: 1
            }
            try {
                const res = await API_.getUserSendCode(data)
                if(res.data.code == 200){
                    Toast.success('发送成功')
                }else if(res.data.code == 0){
                    Toast(res.data.msg)
                    clearInterval(this.timer);
                    this.countDown = 60
                    this.codeStatus = true
                }else{
                    Toast('发送失败')
                    clearInterval(this.timer);
                    this.countDown = 60
                    this.codeText = '重新发送'
                    this.codeStatus = false
                }
            } catch (error) {
                
            }
        }
      },
      onSubmitIntro(values){
        const re = /^1(3|4|5|6|7|8|9)\d{9}$/
        if(!this.introMobile){
          return Toast('手机号不能为空')
        } else if(!re.test(this.introMobile)){
          return Toast('请填写正确的手机格式')
        }else if(!this.introCode){
          return Toast('验证码不能为空')
        } else{
          this.login()
        }
      },
      async login(){
        const data = {
          cuPhone: this.introMobile,
          msgCode: this.introCode
        }
        try {
          const res = await API_.zkmsyPhonelogin(data)
          if(res.data.code == 200){
              this.token = res.data.data
              this.showLogin = false
              sessionStorage.setItem('uToken', res.data.data)
              sessionStorage.setItem('phone', this.introMobile)
              this.list()
          }else{
              Toast('失败')
          }
        } catch (error) {
            
        }
      },
      async list(){
          API_.activityPayList({phone:this.introMobile}).then(res=>{
              if(res.data.code === 200){
                  if(res.data.data.length === 0){
                      return Toast('数据为空')
                  }else{
                      this.lists = res.data.data
                  }
              }else{
                  sessionStorage.removeItem('phone')
                  sessionStorage.removeItem('uToken')
              }
          })
      },
      // 确认
      async confirm(item){
          let obj = {
            // phone:this.introMobile,
            id:item.id,
            // companyName:item.opp_link_company
          }
          API_.activityPayConfirm(obj).then(res=>{
              if(res.data.code === 200){
                  Toast(res.data.data)
                  this.list()
              }
          })
      }
    }
}
</script>
<style lang="scss" scoped>
    .blank{
        height: 3.2vw;
        background: #f9f9f9;
    }
    .confirmcourse-title{
        font-size: 4.8vw;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 600;
        text-align: left;
        color: #181818;
    }
    .confirmcourse-top{
        padding: 4vw;
        border-bottom: 1px solid #efefef;
    }
    .confirmcourse-name{
        padding: 1.87vw 0;
    }
    .confirmcourse-name, .confirmcourse-money{
        font-size: 3.73vw;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 5.33vw;
    }
    .confirmcourse-bottom{
        padding: 2.67vw 3.73vw;
        border-bottom: 1px solid #efefef;
    }
    .confirmcourse-bottom-item{
        display: flex;
        align-items: center;
    }
    .confirmcourse-bottom-item span:first-child{
        font-size: 3.73VW;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #666666;
        line-height: 9.6VW;
    }
    .confirmcourse-bottom-item span:last-child{
        font-size: 3.73VW;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #181818;
        line-height: 9.6VW;
    }
    .button-box{
        padding: 2.67vw 3.73VW;
        display: flex;
        justify-content: right;
        .sure-button{
            width: 30.4vw;
            height: 9.6vw;
            background: #127be4;
            border-radius: 4.8vw;
            font-size: 3.73vw;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            line-height: 9.6vw;
        }
        .active{
            background: #c3c3c3;
        }
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .showlogin {
            width: 3rem;
            border-radius: 0.1rem;
            overflow: hidden;
            background: #fff;
            .login-title {
                padding: 0.15rem 0;
                font-size: 0.14rem;
                font-weight: bold;
                color: #333;
            }
            .login-box {
                padding-bottom: 0.1rem;
            }
            .login-button {
                border-top: 0.01rem solid #eee;
                padding: 0.15rem 0;
                font-size: 0.14rem;
                color: #127BE4;
            }
        }
    }
</style>